export default __webpack_public_path__ + "static/media/google-analytics-2.97dd2340.png";